import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import "./ActiveList.css";
import { ServicegetCommunicationAudiov1, get_link } from "../Services/Service";
import DataTable from './DataTable/DataTableV1';
import { CustomLoader } from "../Services/CommonLibrary";
import { Modal } from "react-bootstrap";
import moment from 'moment';

function CommunicationAudioV1() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState("");
  const [modalTitle, setModalTitle] = useState("");

  const handleClose = () => setShowModal(false);
  const accessFrom = localStorage.getItem("access");

  const [queryParams, setQueryParams] = useState({
    clear: false,
    page: 1,
    pageSize: 50,
    sortField: '',
    sortDirection: '',
    search: '',
    filterData: {
      statusFilter: '',
      dateStartFilter: '',
      dateEndFilter: ''
    }
  });

  useEffect(() => {
    fetchCommunicationAudio(queryParams);
  }, [queryParams]);

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const fetchCommunicationAudio = async (params) => {
    const PostData = {
      status: params.filterData?.statusFilter || '',
      page: params.page,
      pageSize: params.pageSize,
      sortField: params.sortField,
      dateStart: params.filterData?.smsStartFilter ? formatDate(params.filterData?.smsStartFilter) : "",
      dateEnd: params.filterData?.smsEndFilter ? formatDate(params.filterData?.smsEndFilter) : "",
      sortDirection: params.sortDirection,
      search: params.search
    };
    console.log("PostData", PostData);
    setLoading(true);
    try {
      const response = await ServicegetCommunicationAudiov1(PostData);
      setData(response.data.data.communicationlist);
      setTotalRows(Number(response.data.data.total));
    } catch (error) {
      console.error('Error fetching communication audio:', error);
    } finally {
      setLoading(false);
    }
  };

  const openPopup = async (url, type, id) => {
    try {
      const response = await get_link(id, "audio");
      if (response.data.code === 200 && response.data.data.compositionUrl) {
        url = response.data.data.compositionUrl;
      } else {
        throw new Error("Invalid response or missing compositionUrl");
      }

      const audioHtml = (
        <audio
          src={url}
          controls={true}
          autoPlay={true}
          style={{ height: "80px" }}
        />
      );

      setModalTitle("Recording");
      setModalBody(audioHtml);
      setShowModal(true);
    } catch (error) {
      console.error('Error getting audio link:', error);
    }
  };


  const handlePageChange = useCallback((page, pageSize) => {
    setQueryParams(prev => ({
      ...prev,
      page: page + 1,
      pageSize
    }));
  }, []);

  const handleFilterChange = useCallback((filterData) => {
    setQueryParams(prev => ({
      ...prev,
      filterData: { ...prev.filterData, ...filterData },
      page: 1
    }));
  }, []);

  const handleSortChange = ({ field, direction }) => {
    setQueryParams(prev => ({
      ...prev,
      sortField: field,
      sortDirection: direction
    }));
  };

  const handleSearchChange = (searchTerm) => {
    setQueryParams(prev => ({
      ...prev,
      search: searchTerm,
      page: 1
    }));
  };

  const handlePageSizeChange = (newPageSize) => {
    setQueryParams(prev => ({
      ...prev,
      pageSize: newPageSize
    }));
  };

  const columnsV1 = useMemo(() => [
    { field: 'patientName', label: 'Patient Name' },
    { field: 'coachName', label: 'Coach Name' },
    { field: 'mobile', label: 'Mobile' },
    { field: 'createdTime', label: 'Date Time' },
    { field: 'duration', label: 'Duration' },
    { field: 'status', label: 'Status' }
  ], []);

  const extraColumns = useMemo(() => [
    {
      field: 'recording',
      label: 'Recording',
      button: true,
      omit: accessFrom !== 'superadmin',
      content: row => {
        return accessFrom === 'superadmin' ? (
          <button
            className="btn btn-primary btn-sm"
            onClick={() => openPopup(row.compositionUrl, row.type, row.id)}
          >
            Play
          </button>
        ) : null;
      }
    }
  ], [accessFrom]);

  const updateColumnConditions = useMemo(() => [
    {
      condition: (column, row) => column.field === "createdTime",
      content: row => (
        <div className="tdData">
          {moment(row.createdTime).format('DD MMM YYYY hh:mm A')}
        </div>
      )
    }
  ], []);

  return (
    <section className="">
      <div className="row">
        <div className="FL">
          <div className="table-responsive">
            <DataTable
              columns={columnsV1}
              data={data}
              totalRows={totalRows}
              loading={loading}
              csvName="Communication_Audio"
              exportCSVValue={true}
              title="Communication Audio"
              onPageSizeChange={handlePageSizeChange}
              onPageChange={handlePageChange}
              onSortChange={handleSortChange}
              onSearchChange={handleSearchChange}
              onFilterChange={handleFilterChange}
              defaultPageSize={50}
              pageSizeOptions={[25, 50, 100, 200]}
              extraColumns={extraColumns}
              updateColumnConditions={updateColumnConditions}
              filterSmsDate={true}
              showClearbtn={true}
              showFilter={true}
            />
          </div>
        </div>
      </div>

      {loading && <CustomLoader />}

      <Modal dialogClassName="modal-md" show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalBody}
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default CommunicationAudioV1;